import type React from "react";
import type { DropdownProps } from "@/components/mosaic/ui/TileTitle/TileTitle";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";

type Props = {
	items: { id: number; value: string; label: string }[];
	contextValue: string;
	setter: string;
	widgetId: string;
	triggerWidth?: string;
};

export const DropdownWithContext: React.FC<Props & DropdownProps> = ({
	items,
	state,
	onStateChange,
	contextValue,
	setter,
	triggerWidth,
	widgetId,
	...otherProps
}) => {
	const value = (state?.[contextValue] as string) ?? items[0].value;

	return (
		<div className={`w-(${triggerWidth}px)`} {...otherProps}>
			<Select
				value={value}
				onValueChange={(v: any) => onStateChange({ [contextValue]: v })}
				{...otherProps}
			>
				<SelectTrigger className="flex justify-start news-select-trigger text-gold font-bold text-sm h-full w-fit border-none">
					<SelectValue data-testid="selectedValue">{value}</SelectValue>
				</SelectTrigger>

				<SelectContent>
					{items.map((item) => (
						<SelectItem value={item.value} key={item.id} className="w-[70px]">
							{item.label}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	);
};
